import Vue from 'vue';
import VueResource from 'vue-resource'
import VMediaQuery from 'v-media-query'
import ElementUI from 'element-ui'

import MembersList from './components/Members/List.vue'

Vue.use(VueResource);
Vue.use(VMediaQuery);
Vue.use(ElementUI);

new Vue({
    el: '#app',
    
    data: function() {
        return {
            menuActive: false
        }
    },  
    
    components: {
        'members-list': MembersList,
    }
});




// WEBPACK FOOTER //
// ./pub/assets/js/vue/app.js